<template>
  <v-form ref="form" :lazy-validation="true" @submit.prevent="login">
    <v-card-title>E-postadress och lösenord</v-card-title>
    <v-card-text>
      <p>Ange din e-postadress och lösenord för att logga in.</p>
      <v-text-field
        v-model="email"
        required
        type="email"
        label="Din e-postadress *"
        prepend-icon="$sl-user"
        :rules="[rules.required, rules.email]"
      />
      <v-text-field
        v-model="password"
        required
        :type="showPassword ? 'text' : 'password'"
        label="Ditt lösenord *"
        prepend-icon="$sl-lock-password"
        :append-icon="showPassword ? '$sl-view-on' : '$sl-view-off'"
        @click:append="showPassword = !showPassword"
        :rules="[rules.required, rules.pwdLength]"
      />
      <p class="red-text">{{ error }}</p>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="mt-2 mb-7" text type="submit">Login</v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import API from '@/services/api.js'
import {mapActions} from 'vuex'
import {RulesMixin} from '@/components/mixins'
// @group Common
// LoginCardEmail component
export default {
  name: 'LoginCardEmail',

  mixins: [RulesMixin],

  data: () => ({
    email: '',
    password: '',
    error: '',
    showPassword: false
  }),

  methods: {
    ...mapActions('currentuser', ['setCurrentUser']),
    /**
     * @vuese
     * Used to login in the system with email and password
     * @arg The argument is an object representing email and password
     */
    login() {
      //- Trigger validations and bug out on invalid
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }

      API.loginUser({
        email: this.email,
        password: this.password
      })
        .then(res => {
          this.error = ''
          this.$refs.form.reset()
          /**
           * @vuese
           * Used to update current user in local store with the logged in user
           */
          return this.setCurrentUser(res.data)
        })
        .catch(err => {
          if (err && err.response && err.response.data) {
            this.error = err.response.data
          } else {
            this.error = 'Fel vid försök till inloggning.'
          }
        })
    }
  }
}
</script>

<style scoped>
.red-text {
  color: red;
}
</style>
